export default "__VITE_ASSET__d9w2Xpnp__"